module.exports = __webpack_public_path__ + "static/media/IconTemplates_-07.4b679175.svg";